// extracted by mini-css-extract-plugin
module.exports = {"root":"main_root__3uPXC","root_masked":"main_root_masked__26vQB","page":"main_page__2Equ2","page_masked":"main_page_masked__2B3Ic","preload":"main_preload__3hNP_"};